<div>
    @if (!!userLocale()) {
        <div class="best-possible-service">
            <p
                class="header-text paragraph-medium"
                i18n="@@hermes.header_notification.geo_filtering_banner.description2">
                For the best possible service, we invite you to visit our store in
                {{ userLocationCountry }}.
            </p>
            <div class="button-container">
                <button
                    hButton
                    data-testid="'Cancel'"
                    [layout]="BUTTON_LAYOUT.HUG"
                    i18n="@@hermes.header_notification.geo_filtering_banner.go_to"
                    (click)="redirectAlternate()">
                    Yes, go to the <span>&nbsp;{{ userLocationCountry }}&nbsp;</span> site
                </button>
                <button
                    hButton
                    [layout]="BUTTON_LAYOUT.HUG"
                    [variant]="BUTTON_VARIANT.OUTLINED"
                    (click)="continueOnCurrentLocation()">
                    {{ hermesCountrySelector }}
                </button>
            </div>

            <p class="footer-text paragraph-medium">
                <span i18n="@@hermes.header_notification.geo_filtering_banner.locations1"
                    >We are present in {{ totalLocation }} locations, please</span
                >
                <button
                    i18n="@@hermes.header_notification.geo_filtering_banner.locations2"
                    (click)="selectAnotherCountry()"
                    >select yours here</button
                >.
            </p>
        </div>
    } @else {
        <div class="no-delivery-in-your-country">
            <p
                class="header-text paragraph-medium"
                i18n="@@hermes.header_notification.geo_filtering_banner.description1"
                >We do not deliver to your country. You can select another location.</p
            >
            <div class="button-container">
                <button
                    hButton
                    [layout]="BUTTON_LAYOUT.HUG"
                    data-testid="'Cancel'"
                    (click)="continueOnCurrentLocation()">
                    <div class="text">
                        <span i18n="@@hermes.banner.continue_on_hermes">Continue on Hermès</span>
                        <span>&nbsp;{{ "hermes_country_selector" | translate }}</span>
                    </div>
                </button>
                <button
                    hButton
                    [layout]="BUTTON_LAYOUT.HUG"
                    [variant]="BUTTON_VARIANT.OUTLINED"
                    data-testid="Cancel"
                    i18n="@@hermes.header_notification.geo_filtering_banner.select_country"
                    (click)="selectAnotherCountry()">
                    Select another location
                </button>
            </div>
        </div>
    }
</div>
